import Screen from './screen';
import template from './templates/gdpr.html';
import { resizeContentHeight } from '../../utils/resizeContentHeight';
import { ScreenChangeNotice } from '../../customNotice/clientNotice/screenChangeNotice';
export class GdprScreen extends Screen {
    constructor(uic) {
        super("gdpr", uic);
        this.elements = {};
    }
    show(options) {
        this.uic.setOnboarding(this.name);
        this.uic.hideDownloadIcon();
        this.elements['gdpr'].show();
        this.uic.widgetHeaderController.enableEndChatOnCloseButton();
    }
    hide() {
        this.elements['gdpr'].hide();
    }
    bootstrapScreen(chatWindowElement) {
        chatWindowElement.append(template);
        this.elements['widgetWindow'] = $('#chatbotWindow');
        this.elements['gdpr'] = $('#cbot-gdpr-chatwindow');
        this.elements['gdprAcceptButton'] = $('.js-gdpr-btn-accept');
        this.elements['gdprDeclineButton'] = $('.js-gdpr-btn-decline');
        // -----------------------------------------------------------------------------
        //                              GDPR HANDLING
        // -----------------------------------------------------------------------------
        this.elements['gdprAcceptButton'].on('click', $.proxy(() => {
            this.uic.widget.track("chat", "buttonclick", "gdpr_accept");
            this.uic.widget.sendUserMessage('Ja', '');
            this.uic.showScreen('chat');
            this.uic.widget.sendCustomNotice(new ScreenChangeNotice("chat", this.uic.widget.getWidgetApplicationId()));
        }, this));
        this.elements['gdprDeclineButton'].on('click', $.proxy(() => {
            this.uic.widget.track("chat", "buttonclick", "gdpr_decline");
            this.uic.widget.sendUserMessage('Nein', '');
            this.uic.showScreen('chat');
            this.uic.widget.sendCustomNotice(new ScreenChangeNotice("chat", this.uic.widget.getWidgetApplicationId()));
        }, this));
    }
    resizeEvent() {
        resizeContentHeight(this.elements['widgetWindow'], this.elements['gdpr']);
    }
    ;
}
